module.exports = __webpack_public_path__ + "img/ai_letter.dc8f5821.png";